import gql from 'graphql-tag';
import ClientCommon from './client';

export default gql`
  fragment ClientPublic on Client {
    ...ClientCommon
  }
  ${ClientCommon}
`;
